import { useContext } from 'react';

import { EventsContext } from '../context';
import { EventsContextProps } from '../context/types';

export function useAnalyticsEvents(): EventsContextProps {
    return useContext(EventsContext);
}
